export const LOGIN = 'sa-login';
export const LOGOUT = 'sa-logout';
export const ME = 'sa-me'
export const FORGOT_PASSWORD = 'sa-forgot-password';
export const RESET_PASSWORD = 'sa-reset-password';

// Approved Cabinet
export const APPROVED_CABINET = 'sa-list-approved-cabinets';
export const UPDATE_APPROVED_CABINET = 'sa-update-cabinet';
export const APPROVE_CABINET = 'sa-approve-cabinet';
export const EJECT_BATTERY = 'sa-eject-battery';
export const RESTART_CABINET = 'sa-restart-cabinet';
export const RESTART_KIOSK = 'sa-restart-kiosk';
export const CHECK_INVENTORY = 'sa-check-inventory';

export const CABINET_LOGS = 'sa-list-logs';
export const TOGGLE_REMOTE_LOGGING = 'sa-remote-logging';
export const SHORT_LIST_CABINETS = 'sa-short-list-cabinets';
export const SYNC_CABINET_SLOTS = 'sa-sync-cabinet-slots';
export const LOCK_CABINET_SLOT = 'sa-lock-cabinet-slot';
export const OTA_CABINET = 'sa-ota';

// Unapproved Cabinet
export const UNAPPROVED_CABINET = 'sa-list-unapproved-cabinets';
export const REGISTER_CABINET = 'sa-register-cabinet';

// Orders
export const LIST_ORDERS = 'sa-list-orders';
export const ORDER_DETAILS = 'sa-order-detail';
export const ORDER_CABINET = 'sa-list-orders';

// Reports
export const INVOICE_REPORT_LIST = 'sa-list-report';
export const GENERATE_INVOICE_REPORT = 'sa-generate-report';

// Customer
export const LIST_CUSTOMER = 'sa-list-customers';
export const GET_CUSTOMER = 'sa-get-customer';
export const REFUND_CUSTOMER = 'sa-refund-customer';

// Kiosk
export const LIST_KIOSK = 'sa-list-kiosk';

// Advertisements
export const LIST_ADVERTISEMENT = 'sa-list-advertisement';
export const CREATE_ADVERTISEMENT = 'sa-create-advertisement';
export const UPDATE_ADVERTISEMENT = 'sa-update-advertisement';
export const DELETE_ADVERTISEMENT = 'sa-delete-advertisement';

// Coupon Codes
export const LIST_COUPON_CODES = 'sa-list-coupon-code';
export const CREATE_COUPON_CODE = 'sa-create-coupon-code';
export const UPDATE_COUPON_CODE = 'sa-update-coupon-code';

// Users
export const LIST_USERS = 'sa-list-users';
export const CREATE_USERS = 'sa-create-user';
export const UPDATE_USERS = 'sa-update-user';
export const DELETE_USERS = 'sa-delete-user';
export const GET_USER_DETAILS = 'sa-get-user';
export const ASSIGN_ROLES = 'sa-assign-roles';
export const ASSIGN_CABINETS = 'sa-assign-cabinets';
export const UNASSIGN_CABINETS = 'sa-unassign-cabinets';
export const UPDATE_USER_STATUS = 'sa-user-status';

// Roles and Permissions
export const LIST_ROLES = 'sa-list-roles';
export const CREATE_ROLE = 'sa-create-role';
export const LIST_PERMISSIONS = 'sa-list-permissions';
export const DELETE_ROLE = 'sa-delete-role';

// Pricings
export const LIST_PRICING = 'sa-list-pricing';
export const CREATE_PRICING = 'sa-create-pricing';
export const UPDATE_PRICING = 'sa-update-pricing';
export const DELETE_PRICING = 'sa-delete-pricing';
